import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import {
  CropperSettings,
  ImageCropperComponent,
  Bounds,
} from 'ngx-img-cropper';
import {
  ModalTemplate,
  TemplateModalConfig,
  ModalSize,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import {
  ApplicationNewModal,
  ApplicationDetailModal,
  // TemplateNewModal
} from '../../../modals';
import { ApplicationService } from '../../../services';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
  styleUrls: ['./application-list.component.scss'],
})
export class ApplicationListComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  applications: Array<any> = [];
  selectedApplication;
  cropperSettings: CropperSettings;
  data = { image: 'assets/avatar/1.jpg' };
  @ViewChild('cropper') cropper: ImageCropperComponent;
  @ViewChild('uploadModalTemplate') public uploadModalTemplate: ModalTemplate<
    any,
    string,
    string
  >;

  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'applicationName',
        op: 'cn',
        data: '',
      },
    ],
  };
  organizationId: string;
  error: any;
  success: any;
  baseUrl: string = environment.API_SERVER;
  constructor(
    private location: Location,
    private modalService: SuiModalService,
    private applicationSvc: ApplicationService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    // this.getTypes()
    // initialize  organization filter
    this.filter = new AppFilter({ sidx: 'dateCreated' });
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getPage(1);
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.width = 380;
    this.cropperSettings.height = 300;

    this.cropperSettings.croppedWidth = 190;
    this.cropperSettings.croppedHeight = 150;

    this.cropperSettings.canvasWidth = 240;
    this.cropperSettings.canvasHeight = 140;
  }
  cropped(bounds: Bounds) {}

  fileChangeListener($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const myReader: FileReader = new FileReader();
    const that = this;
    myReader.onloadend = (loadEvent: any) => {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    myReader.readAsDataURL(file);
  }

  popUploadModal(app) {
    console.log(app);
    this.selectedApplication = app;
    if (this.selectedApplication.logoPath) {
      this.data.image = `${
        this.baseUrl
      }/public/image/?media=${this.selectedApplication.logoPath.replace(
        /\\/g,
        '/'
      )}`;
    } else {
      this.data = { image: 'assets/avatar/1.jpg' };
    }
    const config = new TemplateModalConfig<any, string, string>(
      this.uploadModalTemplate
    );
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((result) => this.uploadImage())
      .onDeny((result) => {
        /* deny callback */
      });
  }

  uploadImage() {
    this.pending = true;
    this.error = null;
    this.applicationSvc
      .uploadAppLogo({
        applicationId: this.selectedApplication.applicationId,
        body: { image: this.data.image },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Logo updated successfully';
          setTimeout(() => {
            this.getPage(1);
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  goBack() {
    this.location.back();
  }

  addApplication() {
    this.modalService
      .open(
        new ApplicationNewModal('New Application', '', false, ModalSize.Tiny)
      )
      .onApprove((eq) => {
        // this.selectedCertificateHolder = eq;
        // this.startApplication(eq);
        // this.popUploadModal(eq);
        this.getPage(1);
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }

  onView(event) {
    this.modalService
      .open(
        new ApplicationDetailModal(event.applicationName, event, ModalSize.Tiny)
      )
      .onApprove((eq) => {
        // this.selectedCertificateHolder = eq;
        // this.startApplication(eq);
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }

  showToDashboard(app) {
    this.pending = true;
    app.hideFromDashboard = false;
    const self = this;
    this.applicationSvc
      .editApplication({
        applicationId: app.applicationId,
        body: app,
      })
      .subscribe(
        (res) => {
          this.success = 'Application show to dashboard was successful';
          setTimeout(function () {
            self.getPage(1);
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  hideFromDashboard(app) {
    this.pending = true;
    app.hideFromDashboard = true;
    const self = this;
    this.applicationSvc
      .editApplication({
        applicationId: app.applicationId,
        body: app,
      })
      .subscribe(
        (res) => {
          this.success = 'Application hide from dashboard was successful';
          setTimeout(function () {
            self.getPage(1);
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  onHide(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Hide from Dashboard',
          'Are you sure you want to hide from dashboard',
          ModalSize.Tiny
        )
      )
      .onApprove((eq) => {
        // this.selectedCertificateHolder = eq;
        this.hideFromDashboard(event);
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }
  onChangeImage(event) {}

  // uploadImage(app, image) {
  // 	this.pending = true;
  // 	this.error = null;
  // 	this.applicationSvc
  // 		.uploadAppLogo({
  // 			applicationId: app.applicationId,
  // 			body: { image: image }
  // 		})
  // 		.subscribe(
  // 			(res) => {
  // 				this.pending = false;
  // 				this.success = 'Logo updated successfully';
  // 				setTimeout(() => {
  // 					this.getPage(1);
  // 				}, 1000);
  // 			},
  // 			(error) => {
  // 				this.pending = false;
  // 				this.error = error.error;
  // 			}
  // 		);
  // }

  onShow(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Show from Dashboard',
          'Are you sure you want to show from dashboard',
          ModalSize.Tiny
        )
      )
      .onApprove((eq) => {
        // this.selectedCertificateHolder = eq;
        this.showToDashboard(event);
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }
  onEdit(event) {
    this.modalService
      .open(
        new ApplicationNewModal('Edit Application', event, true, ModalSize.Tiny)
      )
      .onApprove((eq) => {
        this.getPage(1);
        // this.selectedCertificateHolder = eq;
        // this.startApplication(eq);
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.applicationSvc.getApplications({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.totalItems = +res.records;
        this.rows = this.filter.rows;
        this.applications = res['rows'];
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'applicationName',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  delete(event: any): void {
    this.pending = true;
    this.error = null;
    this.applicationSvc
      .removeApp({ applicationId: event.applicationId })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Application removed successfully';
          this.getPage(this.filter.page);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Application?',
          'Are you sure you want to remove application?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(event);
      })
      .onDeny(() => {});
  }
  ngOnInit(): void {}
}
